import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { Renseignements } from '../models/Renseignements';
@Component({
  selector: 'app-renseignements',
  templateUrl: './renseignements.component.html'
})
export class RenseignementsComponent implements OnInit {

  @Input() uid = '';
  public current_uid = 'Renseignements'
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
	  
	@Input() renseignements : Renseignements;

  constructor() { }

  public ngOnInit() {
  }
  
  
  
  
  
  

  
  getUid() {
    return this.uid + '_SepSep_' + this.current_uid;
  }  
  
  
}

